export default "__VITE_ASSET__CoRd6Wr3__"